/**
 * Module: Banner Consigliamo (Swiper)
 * Description: Inizializza uno slider Swiper per il blocco "Banner Ti Consigliamo".
 */

export function initBannerConsigliamoSlider() {
  if (typeof Swiper === "undefined") {
    console.warn("Swiper non disponibile per Banner Consigliamo.");
    return;
  }

  const sliders = document.querySelectorAll(".swiper-banner-consigliamo");

  if (sliders.length === 0) return;

  sliders.forEach((slider, index) => {
    const wrapperId =
      slider.closest(".blocco-banner-consigliamo")?.id ||
      `swiper-banner-consigliamo-${index}`;
    console.log(
      `Swiper "Banner Consigliamo" [${index + 1}] → ID: ${wrapperId} 👍`
    );

    const slides = slider.querySelectorAll(".swiper-slide");
    const enableLoop = slides.length > 1;

    new Swiper(slider, {
      slidesPerView: 1,
      loop: enableLoop,
      spaceBetween: 0,
      speed: 600,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: `#${wrapperId} .swiper-button-next`,
        prevEl: `#${wrapperId} .swiper-button-prev`,
      },
      pagination: {
        el: `#${wrapperId} .swiper-pagination`,
        clickable: true,
      },
    });
  });
}
